module.exports = __webpack_public_path__ + "media/images/awards/award-photo-2-81d9e9819c906f0df785cb37c344829c.jpeg";